export default "__VITE_ASSET__BwP$xsM3__"